<template>
	<article class="small-12 articleListingCard">
        <router-link :to="{ name: 'BlogArticle', params: {category: 'sample-category', slug: 'article-slug'} }">
            <div class="small-12 image">
                <picture class="small-12 float-left flex justify-center vertical-align">
                    <img :src="image" alt="Article Feature Image">
                </picture>
            </div>
            <div class="small-12 title">
                <span class="flex small-12 animated">Blog Article Title Goes Here</span>
            </div>
        </router-link>
    </article>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ArticleListing',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			image: 'https://images.ctfassets.net/3wjbn0ndwf7t/4iy74sTOX9vl1EtDgI81Qx/f62b33a9f3f0314e986993d6682dc859/Bad_Debt_vs_Good_Debt.jpg'

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>